import { OnInit, EventEmitter, ElementRef } from '@angular/core';
import { StringHelper } from '../../../../shared/utils/string-helper';
import { OccupancyType } from 'src/app/shared/models/occupancy';
import { ResourceType } from 'src/app/shared/models/resource-type';
import { TranslateService } from '@ngx-translate/core';
import { RoomService } from 'src/app/shared/services/rest/room.service';
var RoomAllocationDesktopComponent = /** @class */ (function () {
    function RoomAllocationDesktopComponent(translate, room) {
        this.translate = translate;
        this.room = room;
        this.openRoomInfo = new EventEmitter();
        this.openSchedule = new EventEmitter();
        /**
         * Event raised on click on "create new"
         *
         * @memberof RoomScheduleItemComponent
         */
        this.createReservation = new EventEmitter();
        /**
         * Event raised when there is time conflict for the current data + time value constellation
         *
         * @memberof RoomScheduleItemComponent
         */
        this.timelineReservationConflicted = new EventEmitter();
        this.displayTimeSpanStart = 5;
        this.displayTimeSpan = 17;
        this.colspans = [1, 3, 3, 3, 3, 3, 1];
    }
    RoomAllocationDesktopComponent.prototype.ngOnInit = function () {
        this.timeStream = [6, 9, 12, 15, 18, 21];
    };
    Object.defineProperty(RoomAllocationDesktopComponent.prototype, "resourceType", {
        get: function () {
            switch (this.model.resourceType) {
                case ResourceType.Raum:
                    return 'ROOM';
                case ResourceType.Gerät:
                    return 'DEVICE';
                default:
                    throw Error("Support for type '" + this.model.resourceType + "' not implemented");
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * checks if the items of a ressource is vacant and open for booking
     * @param item items to check for a possible free time slot
     * @returns {boolean}
     */
    RoomAllocationDesktopComponent.prototype.hasAnyFreeSlot = function (item) {
        return item.some(function (i) { return i.type === OccupancyType.Reservable; });
    };
    RoomAllocationDesktopComponent.prototype.warningClass = function (item) {
        return item.isBookable ? 'text-warning' : 'text-danger';
    };
    /**
      * format time (eg. 15:00)
      *
      * @param {number} hour
      * @param {number} min
      * @returns
      * @memberof RoomAllocationComponent
      */
    RoomAllocationDesktopComponent.prototype.getTimeString = function (hour, min) {
        return StringHelper.formatTime(hour, min);
    };
    /**
      * format timespan (eg. 13:00 -  17:45)
      *
      * @param {ITimeSpan} span
      * @returns
      * @memberof RoomAllocationComponent
      */
    RoomAllocationDesktopComponent.prototype.getTimeSpanString = function (span) {
        var sep = '#';
        var timespan = StringHelper.formatTimeSpan(span.fromHour, span.fromMin, span.toHour, span.toMin, sep);
        var occupiedPhrase = this.translate.instant('OCCUPIED');
        var fromPhrase = this.translate.instant('TIME_FROM');
        var toPhrase = this.translate.instant('TIME_TO');
        return occupiedPhrase + " " + fromPhrase.toLowerCase() + " " + timespan.replace(sep, " " + toPhrase.toLowerCase() + " ");
    };
    /**
     * transforms a list of truthy + falsy values to 1 or 0 string respectively
     * @param boolList a list of truthy + falsy values to transform
     * @returns {string[]}
     */
    RoomAllocationDesktopComponent.prototype.toFlagSet = function (boolList) {
        return boolList.map(function (li) { return Boolean(li) === true ? '1' : '0'; }).join('');
    };
    /**
     * create list of time blocks
     *
     * @returns {ITimeSpan[]}
     * @memberof RoomAllocationComponent
     */
    RoomAllocationDesktopComponent.prototype.getTimeLine = function (scheduleItems) {
        var _this = this;
        if (scheduleItems === null) {
            return [];
        }
        var maxHour = this.displayTimeSpanStart + this.displayTimeSpan;
        // init
        var blocks = new Array(maxHour);
        for (var i = this.displayTimeSpanStart; i <= maxHour; i++) {
            blocks[i] = ({ hour: i, events: [] });
        }
        scheduleItems.filter(function (x) { return x.type !== OccupancyType.Reservable; }).forEach(function (x) {
            var alloc = _this.getTimeSpan(x.from.getHours(), x.from.getMinutes(), x.to.getHours(), x.to.getMinutes(), true);
            // discard when end time is before timeline start time
            if (alloc.toHour < _this.displayTimeSpanStart ||
                alloc.fromHour >= maxHour) {
                return;
            }
            // adjust offsets
            if (alloc.fromHour < _this.displayTimeSpanStart) {
                alloc.fromHour = _this.displayTimeSpanStart;
            }
            if (alloc.toHour > maxHour) {
                alloc.toHour = maxHour;
            }
            if (alloc.toHour === maxHour) {
                alloc.toMin = 0;
            }
            // add
            blocks[alloc.fromHour].events.push(alloc);
        });
        return blocks.slice(this.displayTimeSpanStart, maxHour);
    };
    /**
     * create a ITimeSpan object
     *
     * @private
     * @param {number} fromHour
     * @param {number} fromMin
     * @param {number} toHour
     * @param {number} toMin
     * @param {boolean} [inUse=false]
     * @returns {ITimeSpan}
     * @memberof RoomAllocationDesktopComponent
     */
    RoomAllocationDesktopComponent.prototype.getTimeSpan = function (fromHour, fromMin, toHour, toMin, inUse) {
        if (inUse === void 0) { inUse = false; }
        return { fromHour: fromHour, fromMin: fromMin, toHour: toHour, toMin: toMin, inUse: inUse };
    };
    /**
     * Calculate the distance from left border of progrssbar-frame
     *
     * @param {ITimeSpan} span
     * @returns {string}
     * @memberof RoomAllocationDesktopComponent
     */
    RoomAllocationDesktopComponent.prototype.showTimeStreamLeft = function (span) {
        var timespanMinutes = span.fromHour * 60 + span.fromMin;
        var calcBase = timespanMinutes - (this.displayTimeSpanStart) * 60;
        return Math.round(calcBase / (this.displayTimeSpan * 60) * 100) + '%';
    };
    RoomAllocationDesktopComponent.prototype.showTimeStreamWidth = function (span) {
        var minutes = (span.toHour * 60 + span.toMin) - (span.fromHour * 60 + span.fromMin);
        return Math.round(minutes / (this.displayTimeSpan * 60) * 100) + '%';
    };
    RoomAllocationDesktopComponent.prototype.zebra = function (index) {
        return index % 2 === 0 ? 'bg-light' : '';
    };
    RoomAllocationDesktopComponent.prototype.needSpace = function (index) {
        return index < 21;
    };
    /**
     * handle click on "open roominfo" button
     *
     * @param {IDisplayItem} item
     * @memberof RoomAllocationDesktopComponent
     */
    RoomAllocationDesktopComponent.prototype.onOpenRoomInfo = function (item, event) {
        event.preventDefault();
        this.openRoomInfo.emit(item.resourceId);
    };
    /**
     * handle click on "open room schedule" button
     *
     * @param {IDisplayItem} item
     * @memberof RoomAllocationDesktopComponent
     */
    RoomAllocationDesktopComponent.prototype.onOpenSchedule = function (item) {
        this.openSchedule.emit({
            roomId: item.resourceId,
            designation: item.designation,
            isBookable: item.isBookable,
            hasWarnings: Boolean(item.warning)
        });
    };
    RoomAllocationDesktopComponent.prototype.onClickTimeline = function (event, item) {
        // relative mous position click
        var width = this.progressBar.nativeElement.clientWidth;
        var left = event.offsetX;
        // calc time
        var decimalHour = (this.displayTimeSpan * (left / width)) + this.displayTimeSpanStart;
        var startHour = Math.floor(decimalHour);
        var startMinute = Math.round(60 * (decimalHour % 1));
        // round to 15 min
        var startQuarterHour = Math.round(startMinute / 15) * 15;
        if (startQuarterHour === 60) {
            startQuarterHour = 0;
            startHour++;
        }
        // create from date
        var date = this.baseDate;
        var from = new Date(date.getFullYear(), date.getMonth(), date.getDate(), startHour, startQuarterHour, 0, 0);
        // raise event
        this.createReservation.emit({
            idReservation: null,
            idRessource: item.resourceId,
            from: from,
            to: null
        });
    };
    RoomAllocationDesktopComponent.prototype.onCreateReservationByButton = function (item) {
        var bd = this.baseDate;
        var BASE_MINUTES = 15;
        var nd = new Date();
        var fromDate = new Date(bd.getFullYear(), bd.getMonth(), bd.getDate(), nd.getHours(), Math.round((nd.getMinutes() + 5) / 5) * 5);
        var toDate = new Date(bd.getFullYear(), bd.getMonth(), bd.getDate(), nd.getHours(), Math.round((nd.getMinutes() + 5 + BASE_MINUTES) / 5) * 5);
        // figure out the best time free time slot to load forms with
        var nowTimestamp = fromDate.getTime();
        var nowTillEndtimeDelta = 60 * (BASE_MINUTES + 5) * 1000; // 20min time frame minimum
        var allReservables = item.scheduleItems.filter(function (si) { return si.type === OccupancyType.Reservable; });
        var allEndingInFuture = allReservables
            .filter(function (si) { return si.to.getTime() > nowTimestamp; })
            .sort(function (li, ri) { return li.to.getTime() - ri.to.getTime(); });
        var bestFuture = allEndingInFuture.find(function (i) { return i.to.getTime() - nowTimestamp >= nowTillEndtimeDelta; }) ||
            allEndingInFuture.slice(-1)[0] ||
            allReservables.slice(-1)[0];
        // raise create reservation event
        this.createReservation.emit({
            idReservation: null,
            idRessource: item.resourceId,
            from: nowTimestamp < bestFuture.from.getTime() ? bestFuture.from : new Date(nowTimestamp),
            to: toDate > bestFuture.to ? bestFuture.to : toDate
        });
    };
    /**
     * Last additional column in header must have colspan="2" (space for calendar button)
     *
     * @param {number} index
     * @returns {boolean}
     * @memberof RoomAllocationDesktopComponent
     */
    RoomAllocationDesktopComponent.prototype.isLastHeaderCell = function (index) {
        return index + 1 === this.model.additionalColums.length;
    };
    RoomAllocationDesktopComponent.prototype.notifyOccupiedTimespan = function (occupancySlot) {
        this.timelineReservationConflicted.emit(occupancySlot);
    };
    return RoomAllocationDesktopComponent;
}());
export { RoomAllocationDesktopComponent };
var AllocationTableModel = /** @class */ (function () {
    function AllocationTableModel() {
    }
    return AllocationTableModel;
}());
export { AllocationTableModel };
/**
 * Row model for AllocationTableModel
 *
 * @export
 * @class AllocationTableItem
 */
var AllocationTableItem = /** @class */ (function () {
    function AllocationTableItem() {
    }
    return AllocationTableItem;
}());
export { AllocationTableItem };
